import Vue from 'vue'
const Cookie = process.client ? require('js-cookie') : undefined

Vue.mixin({
  methods: {
    // $_bookmark_toast() {
    //   if (process.client) {
    //     // bookmark
    //     const bookmark = JSON.parse(
    //       Cookie.get('disabled-bookmark-toast') || null
    //     )
    //     if (bookmark === undefined) {
    //       Cookie.set('disabled-bookmark-toast', false, {
    //         expires: 1,
    //         secure: true,
    //       })
    //     }
    //     //   const pathBookmark = ['lang', 'index']  && pathBookmark.includes(this.$route.name)
    //     if (!bookmark) {
    //       const id = `bookmark-toast`
    //       const headerContent = this.$createElement(
    //         'div',
    //         {
    //           class: [
    //             'd-flex',
    //             'align-items-center',
    //             'justify-content-between',
    //           ],
    //         },
    //         [
    //           this.$createElement('div', { class: ['mr-auto', 'd-flex'] }, [
    //             this.$createElement('img', {
    //               attrs: {
    //                 src: 'https://ofm-cdn0.ofm.co.th/images/logo/ic_Fm-OFM.png',
    //                 width: '30px',
    //                 height: '30px',
    //               },
    //               class: ['mr-2 mt-2 mb-auto'],
    //             }),
    //             // description
    //             this.$createElement(
    //               'div',
    //               {
    //                 class: ['mr-1'],
    //               },
    //               [
    //                 this.$createElement(
    //                   'div',
    //                   {
    //                     class: ['fs-16', 'fw-heavy'],
    //                   },
    //                   ['ช้อปง่าย สะดวก และรวดเร็วกว่าเดิม!']
    //                 ),
    //                 this.$createElement(
    //                   'div',
    //                   {
    //                     class: ['fs-12 mt-2'],
    //                   },
    //                   [
    //                     'แค่กด ‘⭐️’ ที่ด้านขวาของเบราว์เซอร์ หรือ กดปุ่ม ‘Ctrl’ หรือ ‘Cmd’ และ ‘D’ (Ctrl+D /Cmd+D) ที่คีย์บอร์ด ก็จะสามารถเพิ่มลิงก์นี้ไปยังบุ๊กมาร์กของคุณเพื่อเข้าสั่งซื้อภายหลังได้ทันที',
    //                   ]
    //                 ),
    //               ]
    //             ),
    //           ]),
    //           this.$createElement('b-icon-x', {
    //             class: ['ml-auto mb-auto'],
    //             on: {
    //               click: () => {
    //                 this.$bvToast.hide(id)
    //                 Cookie.set('disabled-bookmark-toast', true, {
    //                   expires: 1,
    //                   secure: true,
    //                 })
    //               },
    //             },
    //           }),
    //         ]
    //       )

    //       this.$bvToast.toast([headerContent], {
    //         id: id,
    //         append: true,
    //         noAutoHide: true,
    //         toaster: 'b-toaster-top-right bookmark-toast',
    //         noCloseButton: true,
    //       })
    //     }
    //   }
    // },
    $_set_page(path) {
      if (process.client) {
        Cookie.set(`page_${process.env.NODE_ENV}`, path, {
          expires: new Date(new Date().getTime() + 60 * 60 * 1000), // 60 minutes from now// 5 minutes from now
          secure: true,
          domain: process.env.NODE_ENV.includes('local')
            ? 'localhost'
            : '.ofm.co.th', // Use localhost for local environment, otherwise use .ofm.co.th
        })
      }
    },
  },
})
